/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DebugRouteImport } from './routes/debug'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AppSyncRouteImport } from './routes/_app.sync'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppClubRouteImport } from './routes/_app.club'
import { Route as AppTeamsIndexRouteImport } from './routes/_app.teams.index'
import { Route as AppPlayersIndexRouteImport } from './routes/_app.players.index'
import { Route as AppJobsIndexRouteImport } from './routes/_app.jobs.index'
import { Route as AppTeamsTeamIdRouteImport } from './routes/_app.teams.$teamId'
import { Route as AppJobsJobIdRouteImport } from './routes/_app.jobs.$jobId'
import { Route as AdminAdminClubsRouteImport } from './routes/_admin.admin.clubs'
import { Route as AppMatchesMatchIdSheetRouteImport } from './routes/_app.matches.$matchId.sheet'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugRoute = DebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin/login',
  path: '/admin/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSyncRoute = AppSyncRouteImport.update({
  id: '/sync',
  path: '/sync',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppClubRoute = AppClubRouteImport.update({
  id: '/club',
  path: '/club',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamsIndexRoute = AppTeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlayersIndexRoute = AppPlayersIndexRouteImport.update({
  id: '/players/',
  path: '/players/',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsIndexRoute = AppJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamsTeamIdRoute = AppTeamsTeamIdRouteImport.update({
  id: '/teams/$teamId',
  path: '/teams/$teamId',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsJobIdRoute = AppJobsJobIdRouteImport.update({
  id: '/jobs/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => AppRoute,
} as any)
const AdminAdminClubsRoute = AdminAdminClubsRouteImport.update({
  id: '/admin/clubs',
  path: '/admin/clubs',
  getParentRoute: () => AdminRoute,
} as any)
const AppMatchesMatchIdSheetRoute = AppMatchesMatchIdSheetRouteImport.update({
  id: '/matches/$matchId/sheet',
  path: '/matches/$matchId/sheet',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/debug': typeof DebugRoute
  '/login': typeof LoginRoute
  '/club': typeof AppClubRoute
  '/dashboard': typeof AppDashboardRoute
  '/sync': typeof AppSyncRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/clubs': typeof AdminAdminClubsRoute
  '/jobs/$jobId': typeof AppJobsJobIdRoute
  '/teams/$teamId': typeof AppTeamsTeamIdRoute
  '/jobs/': typeof AppJobsIndexRoute
  '/players/': typeof AppPlayersIndexRoute
  '/teams/': typeof AppTeamsIndexRoute
  '/matches/$matchId/sheet': typeof AppMatchesMatchIdSheetRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/debug': typeof DebugRoute
  '/login': typeof LoginRoute
  '/club': typeof AppClubRoute
  '/dashboard': typeof AppDashboardRoute
  '/sync': typeof AppSyncRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/clubs': typeof AdminAdminClubsRoute
  '/jobs/$jobId': typeof AppJobsJobIdRoute
  '/teams/$teamId': typeof AppTeamsTeamIdRoute
  '/jobs': typeof AppJobsIndexRoute
  '/players': typeof AppPlayersIndexRoute
  '/teams': typeof AppTeamsIndexRoute
  '/matches/$matchId/sheet': typeof AppMatchesMatchIdSheetRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminRouteWithChildren
  '/_app': typeof AppRouteWithChildren
  '/debug': typeof DebugRoute
  '/login': typeof LoginRoute
  '/_app/club': typeof AppClubRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/sync': typeof AppSyncRoute
  '/admin/login': typeof AdminLoginRoute
  '/_admin/admin/clubs': typeof AdminAdminClubsRoute
  '/_app/jobs/$jobId': typeof AppJobsJobIdRoute
  '/_app/teams/$teamId': typeof AppTeamsTeamIdRoute
  '/_app/jobs/': typeof AppJobsIndexRoute
  '/_app/players/': typeof AppPlayersIndexRoute
  '/_app/teams/': typeof AppTeamsIndexRoute
  '/_app/matches/$matchId/sheet': typeof AppMatchesMatchIdSheetRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/debug'
    | '/login'
    | '/club'
    | '/dashboard'
    | '/sync'
    | '/admin/login'
    | '/admin/clubs'
    | '/jobs/$jobId'
    | '/teams/$teamId'
    | '/jobs/'
    | '/players/'
    | '/teams/'
    | '/matches/$matchId/sheet'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/debug'
    | '/login'
    | '/club'
    | '/dashboard'
    | '/sync'
    | '/admin/login'
    | '/admin/clubs'
    | '/jobs/$jobId'
    | '/teams/$teamId'
    | '/jobs'
    | '/players'
    | '/teams'
    | '/matches/$matchId/sheet'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/_app'
    | '/debug'
    | '/login'
    | '/_app/club'
    | '/_app/dashboard'
    | '/_app/sync'
    | '/admin/login'
    | '/_admin/admin/clubs'
    | '/_app/jobs/$jobId'
    | '/_app/teams/$teamId'
    | '/_app/jobs/'
    | '/_app/players/'
    | '/_app/teams/'
    | '/_app/matches/$matchId/sheet'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  DebugRoute: typeof DebugRoute
  LoginRoute: typeof LoginRoute
  AdminLoginRoute: typeof AdminLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug': {
      id: '/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof DebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/admin/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/sync': {
      id: '/_app/sync'
      path: '/sync'
      fullPath: '/sync'
      preLoaderRoute: typeof AppSyncRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/club': {
      id: '/_app/club'
      path: '/club'
      fullPath: '/club'
      preLoaderRoute: typeof AppClubRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/teams/': {
      id: '/_app/teams/'
      path: '/teams'
      fullPath: '/teams/'
      preLoaderRoute: typeof AppTeamsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/players/': {
      id: '/_app/players/'
      path: '/players'
      fullPath: '/players/'
      preLoaderRoute: typeof AppPlayersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs/': {
      id: '/_app/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AppJobsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/teams/$teamId': {
      id: '/_app/teams/$teamId'
      path: '/teams/$teamId'
      fullPath: '/teams/$teamId'
      preLoaderRoute: typeof AppTeamsTeamIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs/$jobId': {
      id: '/_app/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof AppJobsJobIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_admin/admin/clubs': {
      id: '/_admin/admin/clubs'
      path: '/admin/clubs'
      fullPath: '/admin/clubs'
      preLoaderRoute: typeof AdminAdminClubsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_app/matches/$matchId/sheet': {
      id: '/_app/matches/$matchId/sheet'
      path: '/matches/$matchId/sheet'
      fullPath: '/matches/$matchId/sheet'
      preLoaderRoute: typeof AppMatchesMatchIdSheetRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAdminClubsRoute: typeof AdminAdminClubsRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdminClubsRoute: AdminAdminClubsRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppRouteChildren {
  AppClubRoute: typeof AppClubRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppSyncRoute: typeof AppSyncRoute
  AppJobsJobIdRoute: typeof AppJobsJobIdRoute
  AppTeamsTeamIdRoute: typeof AppTeamsTeamIdRoute
  AppJobsIndexRoute: typeof AppJobsIndexRoute
  AppPlayersIndexRoute: typeof AppPlayersIndexRoute
  AppTeamsIndexRoute: typeof AppTeamsIndexRoute
  AppMatchesMatchIdSheetRoute: typeof AppMatchesMatchIdSheetRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppClubRoute: AppClubRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppSyncRoute: AppSyncRoute,
  AppJobsJobIdRoute: AppJobsJobIdRoute,
  AppTeamsTeamIdRoute: AppTeamsTeamIdRoute,
  AppJobsIndexRoute: AppJobsIndexRoute,
  AppPlayersIndexRoute: AppPlayersIndexRoute,
  AppTeamsIndexRoute: AppTeamsIndexRoute,
  AppMatchesMatchIdSheetRoute: AppMatchesMatchIdSheetRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  DebugRoute: DebugRoute,
  LoginRoute: LoginRoute,
  AdminLoginRoute: AdminLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
